import CommonFunctions from "../../wwwroot_src/src/GlobalScripts/CommonFunctions";

export interface DropDownMenuOptions {
    dataValueField: string;
    headerTemplate: string;
    itemTemplate: string;
    footerTemplate: string;
    dataTextField: string;
    targetId: string;
    dataSource: kendo.data.DataSource;
    onItemClick: (item) => void;
    onHeaderClick: (item) => void;
    onFooterClick: (item) => void;
    id: string;
}

interface UuidItem {
    uid: string;
}

export class DropDownMenu extends kendo.ui.Widget {
    dataSource: kendo.data.DataSource;
    itemTemplateCompiled: (data) => string;
    headerTemplateCompiled: (data) => string;
    footerTemplateTemplateCompiled: (data) => string;
    options: DropDownMenuOptions;
    isLoaded: boolean;
    preventClose: boolean; //fix for chrome closing popup

    constructor(element: Element, options?: DropDownMenuOptions) {
        super(element, options);
        if (options) {
            this.options = options;
            if (Array.isArray(options.dataSource)) {
                this.dataSource = new kendo.data.DataSource({ data: options.dataSource });
            } else {
                this.dataSource = new kendo.data.DataSource(<any>options.dataSource); 
            }
            if (options.itemTemplate) {
                this.itemTemplateCompiled = kendo.template(options.itemTemplate);
            }
            if (options.headerTemplate) {
                this.headerTemplateCompiled = kendo.template(options.headerTemplate);
            }
            if (options.footerTemplate) {
                this.footerTemplateTemplateCompiled = kendo.template(options.footerTemplate);
            }
            this.target.on("click", this.clicked);
        }
        this.isLoaded = false;
        this.preventClose = true;
    }

    get target() {
        if (this.options.targetId.indexOf(".") === 0 || this.options.targetId.indexOf("#") === 0) {
            return $(`${this.options.targetId}`);
        }
        return $(`#${this.options.targetId}`);
    }

    get id() {
        if (this.options.id.indexOf(".") === 0 || this.options.id.indexOf("#") === 0) {
            return $(`${this.options.id}`);
        }
        return $(`#${this.options.id}`);
    }

    get menu(): kendo.ui.ContextMenu {
        if (this.id.data("kendoContextMenu")) {
            return this.id.data().kendoContextMenu;
        }

        $(".orphyDropDownMenu").each((index, item) => {
            if (item.id === this.options.id) {
                const data = $(item).data();
                if (data) {
                    //if there is an un disposed widget with same name, destroy it
                    if (data.kendoContextMenu) {
                        data.kendoContextMenu.destroy();
                    }
                    if (data.kendoDropDownMenu) {
                        data.kendoDropDownMenu.destroy();
                    }
                }
            }
        });
        this.createMenu();
        return this.id.data().kendoContextMenu;
    }

    setDataSource = (ds: kendo.data.DataSource) => {
        this.dataSource = ds;
    }

    destroyDropDown = () => {
        this.target.off("click");
        this.menu.destroy();
        this.destroy();
    }

    private clicked = () => {
        if (!this.isLoaded) {
            this.createMenu();
            CommonFunctions.isLoading($(this.target));
            this.dataSource.read().then(() => this.readCompleted()).then(() => this.menu.open(this.target));
        } else {
            this.readCompleted();
            this.menu.open(this.target);
        }
    }

    private readCompleted = () => {
        const menu = this.menu;
        const childs = this.menu.element.children();
        menu.remove(childs);
        CommonFunctions.isLoadeded($(this.target));
        if (this.headerTemplateCompiled) {
            menu.append({ text: this.itemTemplateCompiled(menu), encoded: false, attr: { itemType: "header" } });
        }

        this.dataSource.data()
            .forEach((item: UuidItem) => {
                const value = this.options.dataTextField ? item[this.options.dataTextField] : item;
                const menuItem = { text: value, encoded: true, attr: { uid: item.uid, itemType: "item" } };
                if (this.itemTemplateCompiled) {
                    menuItem.text = this.itemTemplateCompiled(item);
                    menuItem.encoded = false;
                }
                menu.append(menuItem);
            });
        if (this.footerTemplateTemplateCompiled) {
            menu.append({ text: this.footerTemplateTemplateCompiled(menu), encoded: false, attr: { itemType: "footer" } });
        }
        this.isLoaded = true;
    }

    private createMenu() {
        this.id.kendoContextMenu({
            target: this.target,
            select: this.itemSelected,
            animation: false,
            alignToAnchor: true,
            orientation: "vertical",
            showOn: "click",
            activate: (e) => {
                try {
                    const animationContainer = $(e.item).closest(".k-animation-container");
                    if (animationContainer.length === 0) {
                        return;
                    }
                    const left = animationContainer.css("left");
                    const leftValue = parseFloat(left.replace("px", ""));
                    if (Number.isNaN(leftValue)) {
                        return;
                    }
                    animationContainer.css("left", `${leftValue - 20}px`);
                } catch (error) {
                    console.error("Error adjusting animation container position:", error);
                }
            },
            close: () => {
                this.preventClose = false;
            },
            deactivate: () => {
                this.preventClose = true;
            }
        });
    }

    private itemSelected = (e) => {
        const itemType = $(e.item).attr("itemType");
        if (itemType === "header") {
            if (this.options.onHeaderClick) {
                this.options.onHeaderClick(this);
            }
        } else if (itemType === "footer") {
            if (this.options.onFooterClick) {
                this.isLoaded = false;
                this.options.onFooterClick(this);
            }
        } else {
            const uid = $(e.item).attr("uid");
            if (uid) {
                const item = this.dataSource.getByUid(uid);
                if (this.options.onItemClick) {
                    this.options.onItemClick(item);
                }
            }
        }
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
DropDownMenu.fn = DropDownMenu.prototype;
// Deep clone the widget default options
DropDownMenu.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
DropDownMenu.fn.options.name = "DropDownMenu";
// Create a jQuery plugin.
kendo.ui.plugin(DropDownMenu);

interface JQuery {
    dropDownMenu(options?: DropDownMenuOptions): JQuery;
}
